import { useEffect, useCallback, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Logo } from 'components/Logo';
// import { Input } from 'components/Input';

import { Routes, Category } from 'router/routes';

import { getCompanies as getCompaniesAction } from 'modules/companies/actions';

import { Store } from 'types';
import { useAction } from 'utils';

import { List } from './components/List';
import { Footer } from './components/Footer';
import { LogoutModal } from './components/LogoutModal';

import styles from './styles.module.scss';

export const Sidebar: React.FC<RouteComponentProps> = ({ history, location }) => {
  const [logoutModalOpened, setLogoutModalOpened] = useState(false);
  const { data } = useSelector((store: Store) => store.user);
  const {
    loading,
    data: { results },
  } = useSelector((store: Store) => store.companies);
  const getCompanies = useAction(getCompaniesAction.request);

  useEffect(() => {
    getCompanies({ limit: 10, offset: 0 });
  }, [getCompanies]);

  const handleNavigation = useCallback(
    (companyId: number, category: Category) => {
      history.push(Routes.company(category, companyId));
    },
    [history],
  );

  const openLogoutModal = useCallback(() => {
    setLogoutModalOpened(true);
  }, []);

  const closeLogoutModal = useCallback(() => {
    setLogoutModalOpened(false);
  }, []);

  return (
    <aside className={styles.container}>
      <Logo />
      {/* <Input
        searchInput
        name="search"
        placeholder="Search"
        className={styles.search_container}
        value=""
        onChange={() => {}}
      /> */}
      <List
        loading={loading}
        currentPathname={location.pathname}
        companies={results}
        onSelectedCategoryChange={handleNavigation}
      />
      <Footer email={data!.user.email} onLogout={openLogoutModal} />
      {logoutModalOpened && <LogoutModal onClose={closeLogoutModal} />}
    </aside>
  );
};
